// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 94 ? "pdfjsWorker" : chunkId) + "." + {"94":"212a80b9","787":"2c3184ed","897":"51b1175b"}[chunkId] + ".chunk.js";
};